export enum TallyTypes {
  GetAllPageCountsRequest = 'Tally.GetAllPageCounts.Request',
  GetAllPageCountsSuccess = 'Tally.GetAllPageCounts.Success',
  GetAllPageCountsFailure = 'Tally.GetAllPageCounts.Failure',
}
